import { useState } from "react";

import api from "../../../api/api";
import HintModal from "../common/hint-modal";

import useWordPressSettings from "./hooks/useWordpressSettings";

const GenerateWordpressSettings = () => {
  // const heading = "FIRM SETTINGS TITLE WITH CENTERED TEXT";
  const points = [
    "Firm settings panel instruction point one",
    "Firm settings panel instruction point two",
    "Firm settings panel instruction point three",
  ];

  const { data: WordpressCreds, refetch } = useWordPressSettings();
  const [_data, setData] = useState(null);
  const [_error, setError] = useState(null);
  const [showSecret, setShowSecret] = useState(false);
  const [showHints, setShowHints] = useState(false);

  const handleHintToggle = () => {
    setShowHints(!showHints);
  };

  const maskSecret = (secret) => {
    if (!secret) return "";
    return secret.slice(0, 22) + "***********";
  };
  const generateCreds = async () => {
    try {
      const response = await api.get("/api/firmsetting-page/generate-wordpress-creds/");
      setData(response.data);
      refetch();
    } catch (error) {
      setError(error);
    }
  };

  return (
    <div className="tab-pane fade firm-settings-user-perms-fs active show">
      <div className="d-flex justify-content-between">
        <h2 className="fw-bold">WordPress Settings</h2>
        <div
          onClick={() => {
            handleHintToggle();
          }}
        >
          <i className="ic ic-19 ic-help-2 cursor-pointer" />
        </div>
      </div>
      <div className="mt-3 w-50 ms-3">
        {!WordpressCreds?.client_id ? (
          <button onClick={generateCreds} className="btn btn-primary height-25 py-0">
            Generate Client ID and Secret
          </button>
        ) : (
          <div className="client-info">
            <div className="mb-3">
              <strong>Client ID:</strong> {WordpressCreds.client_id}
            </div>
            <div className="mb-3 d-flex align-items-center">
              <div className="me-2">
                <strong>Client Secret:</strong>{" "}
                {showSecret
                  ? WordpressCreds.client_secret
                  : maskSecret(WordpressCreds.client_secret)}
              </div>
            </div>
            <button
              className="btn btn-primary d-flex align-items-center justify-content-center height-25"
              onClick={() => setShowSecret(!showSecret)}
              style={{ width: "90px" }}
            >
              {showSecret ? "Hide" : "Show"}
            </button>
          </div>
        )}
      </div>
      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
    </div>
  );
};

export default GenerateWordpressSettings;
